/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Leagues_HintInputs */



/**
* | output |
* | --- |
* | "Nothing selected = no league restriction." |
*
* @param {Promo_Leagues_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_leagues_hint = /** @type {((inputs?: Promo_Leagues_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Leagues_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rien sélectionné = aucune restriction de ligue.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nada seleccionado = sin restricción de liga.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nada selecionado = sem restrição de liga.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna selezione = nessuna restrizione di campionato.")
	return /** @type {LocalizedString} */ ("Nothing selected = no league restriction.")
});